"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMinMaxChargeDate = void 0;
const enums_1 = require("../enums");
const calculateMinMaxChargeDate = (planFamily, currentDate, nextRenewalDate) => {
    const absoluteMaxDate = new Date();
    absoluteMaxDate.setFullYear(currentDate.getFullYear() + 1);
    absoluteMaxDate.setHours(0, 0, 0, 0);
    const minDate = new Date();
    minDate.setTime(currentDate.getTime() + enums_1.MS.DAY);
    let chargeDateOffset = nextRenewalDate.getTime() - currentDate.getTime();
    if (chargeDateOffset < 0) {
        chargeDateOffset = 0;
    }
    let planFamilyOffset = 0;
    switch (planFamily) {
        case 'monthly':
            planFamilyOffset = 2;
            break;
        case 'quarterly':
            planFamilyOffset = 6;
            break;
        case 'biannual':
        case 'annual':
        default:
            planFamilyOffset = 12;
    }
    let maxMonth = currentDate.getMonth() + planFamilyOffset;
    let maxYear = currentDate.getFullYear();
    if (maxMonth > 11) {
        maxMonth = maxMonth - 12;
        maxYear++;
    }
    const maxDate = new Date();
    maxDate.setFullYear(maxYear);
    maxDate.setMonth(maxMonth);
    maxDate.setTime(maxDate.getTime() + chargeDateOffset);
    maxDate.setHours(0);
    maxDate.setMinutes(0);
    maxDate.setSeconds(0);
    maxDate.setMilliseconds(0);
    if (maxDate.getTime() > absoluteMaxDate.getTime()) {
        maxDate.setTime(absoluteMaxDate.getTime());
    }
    return {
        minDate,
        maxDate,
    };
};
exports.calculateMinMaxChargeDate = calculateMinMaxChargeDate;
